import TrustBadgePill from './TrustBadgePill';

export default function WarrantyBadge() {
  return <TrustBadgePill id="warranty" />;
}
